import * as React from "react";
import type { SVGProps } from "react";

const FacilityCarPoolParking = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0037 16.253H11.669V16.6698C11.669 17.1303 11.2958 17.5035 10.8353 17.5035H10.0016C9.54122 17.5035 9.16797 17.1303 9.16797 16.6698V15.2109C9.16797 14.4051 9.82116 13.752 10.6269 13.752H16.0458C16.8516 13.752 17.5048 14.4051 17.5048 15.2109V16.6698C17.5048 17.1303 17.1315 17.5035 16.6711 17.5035H15.8374C15.377 17.5035 15.0037 17.1303 15.0037 16.6698V16.253Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1172 13.8483L10.5965 11.7996C10.7288 11.234 11.2332 10.834 11.8141 10.834H14.8575C15.4384 10.834 15.9428 11.234 16.0751 11.7996L16.5544 13.8483"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.201 13.4371L9.16797 12.9181"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4688 13.4371L17.5018 12.9181"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66684 5.83203V9.58359"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66406 5.83203H7.97711C8.29219 5.83203 8.59436 5.95719 8.81715 6.17999C9.03994 6.40278 9.1651 6.70495 9.1651 7.02003V7.02003C9.1651 7.67614 8.63322 8.20802 7.97711 8.20802H6.66406"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3364 7.51835C13.3384 5.96616 12.7236 4.47678 11.6272 3.37803H11.6271L11.6077 3.35849C9.31395 1.09515 5.62117 1.1149 3.35178 3.40266C1.08238 5.69042 1.09238 9.38323 3.37413 11.6587L5.87538 14.1683"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityCarPoolParking.displayName = "FacilityCarPoolParking";

export default FacilityCarPoolParking;
